import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BLACK_500, getTestId, InfoTag, isValidObject, Lottie, useBreakpoint } from '@airtel/air-design-system';
import React, { useEffect } from 'react';
import { ImageBackground, Pressable, View } from 'react-native';
import { ButtonWidget } from '../button-widget';
import { ImageWidget } from '../image-widget';
import { SectionTitleWidget } from '../section-title-widget';
import { TypographyWidget } from '../typography-widget';
import { DynamicCardImg } from './components/DynamicDataCardImg';
import { ImagePositionTypes } from './DynamicDataCardWidgetPropTypes';
import { getDynamicDataCardWidgetStyles } from './DynamicDataCardWidgetStyles';
export var DynamicDataCardWidgetComponent = props => {
  var _a, _b;
  var id = props.id,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'DynamicDataCardWidget' : _props$testID,
    style = props.style,
    cardSectionTitleProps = props.cardSectionTitleProps,
    cardValueUnitProps = props.cardValueUnitProps,
    cardSupportingInfoProps = props.cardSupportingInfoProps,
    cardSupportingDescriptionProps = props.cardSupportingDescriptionProps,
    _props$pressableAcces = props.pressableAccessibilityProps,
    pressableAccessibilityProps = _props$pressableAcces === void 0 ? {} : _props$pressableAcces,
    infoSectionStyle = props.infoSectionStyle,
    buttonProps = props.buttonProps,
    imageProps = props.imageProps,
    infoTagSubType = props.infoTagSubType,
    infoTagText = props.infoTagText,
    headingType = props.headingType,
    _props$isDisabled = props.isDisabled,
    isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled,
    _props$isCardOnPressD = props.isCardOnPressDisabled,
    isCardOnPressDisabled = _props$isCardOnPressD === void 0 ? true : _props$isCardOnPressD,
    _props$infoTagMarginB = props.infoTagMarginBottom,
    infoTagMarginBottom = _props$infoTagMarginB === void 0 ? '' : _props$infoTagMarginB,
    _props$withBackground = props.withBackgroundImage,
    withBackgroundImage = _props$withBackground === void 0 ? false : _props$withBackground,
    backgroundImageProps = props.backgroundImageProps,
    onUserAction = props.onUserAction,
    _props$imagePosition = props.imagePosition,
    imagePosition = _props$imagePosition === void 0 ? ImagePositionTypes.TOP : _props$imagePosition,
    onCardPressMetaData = props.onCardPressMetaData,
    lottieViewProps = props.lottieViewProps,
    onCardPressHandler = props.onCardPressHandler,
    descrptionNoOfLines = props.descrptionNoOfLines,
    headingNoOfLines = props.headingNoOfLines,
    _props$type = props.type,
    type = _props$type === void 0 ? 'default' : _props$type,
    _props$resizeMode = props.resizeMode,
    resizeMode = _props$resizeMode === void 0 ? 'cover' : _props$resizeMode,
    logoResizeMode = props.logoResizeMode,
    heading = props.heading,
    description = props.description,
    infoTagSize = props.infoTagSize,
    infoTagType = props.infoTagType,
    logoUrl = props.logoUrl,
    showLogo = props.showLogo,
    logoStyles = props.logoStyles,
    infoIconName = props.infoIconName,
    infoIconPosition = props.infoIconPosition,
    showCtaAtBottom = props.showCtaAtBottom,
    cardImgProps = props.cardImgProps,
    showInfoIcon = props.showInfoIcon,
    cardSectionTitleRadioButtonSelected = props.cardSectionTitleRadioButtonSelected,
    tooltipProps = props.tooltipProps,
    wrapperStyle = props.wrapperStyle;
  var DynamicDataCardWidgetStyles = getDynamicDataCardWidgetStyles(((_a = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.leftCta) === null || _a === void 0 ? void 0 : _a.buttonType) || ((_b = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.rightCta) === null || _b === void 0 ? void 0 : _b.buttonType));
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen,
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var _React$useState = React.useState(false),
    animatedView = _React$useState[0],
    setAnimatedView = _React$useState[1];
  var imageSize = isSmallScreen ? 32 : 48;
  var cardSupportingDescriptionNumberOfLines = isValidObject(cardSupportingInfoProps) ? 2 : 3;
  var lottieView = null;
  useEffect(() => {
    if (lottieViewProps === null || lottieViewProps === void 0 ? void 0 : lottieViewProps.lottieUrl) {
      setTimeout(() => {
        setAnimatedView(true);
      }, (lottieViewProps === null || lottieViewProps === void 0 ? void 0 : lottieViewProps.animationDelay) || 1000);
    }
  }, [lottieViewProps === null || lottieViewProps === void 0 ? void 0 : lottieViewProps.animationDelay]);
  useEffect(() => {
    if (!(lottieViewProps === null || lottieViewProps === void 0 ? void 0 : lottieViewProps.loop)) {
      setTimeout(() => {
        setAnimatedView(false);
        (lottieViewProps === null || lottieViewProps === void 0 ? void 0 : lottieViewProps.onAnimationFinishAction) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, lottieViewProps === null || lottieViewProps === void 0 ? void 0 : lottieViewProps.onAnimationFinishAction), Object.assign({}, props)));
      }, (lottieViewProps === null || lottieViewProps === void 0 ? void 0 : lottieViewProps.animationDuration) || 4000);
    }
  }, [animatedView]);
  if (lottieViewProps === null || lottieViewProps === void 0 ? void 0 : lottieViewProps.lottieUrl) {
    lottieView = _jsx(Lottie, Object.assign({
      onAnimationFinish: () => {
        setAnimatedView(false);
        (lottieViewProps === null || lottieViewProps === void 0 ? void 0 : lottieViewProps.onAnimationFinishAction) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, lottieViewProps === null || lottieViewProps === void 0 ? void 0 : lottieViewProps.onAnimationFinishAction), Object.assign({}, props)));
      },
      loop: lottieViewProps === null || lottieViewProps === void 0 ? void 0 : lottieViewProps.loop,
      uri: lottieViewProps === null || lottieViewProps === void 0 ? void 0 : lottieViewProps.lottieUrl,
      hideOnAnimationFinish: true,
      style: {
        width: (lottieViewProps === null || lottieViewProps === void 0 ? void 0 : lottieViewProps.width) || imageSize,
        height: (lottieViewProps === null || lottieViewProps === void 0 ? void 0 : lottieViewProps.height) || imageSize,
        alignSelf: 'center'
      }
    }, getTestId(testID, 'lottie')));
  }
  var DynamicDataCardJsx = _jsx(Pressable, Object.assign({
    onPress: () => {
      onCardPressHandler === null || onCardPressHandler === void 0 ? void 0 : onCardPressHandler();
      onCardPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, onCardPressMetaData), props));
    }
  }, getTestId(testID), {
    style: [DynamicDataCardWidgetStyles.container, style]
  }, pressableAccessibilityProps, {
    children: animatedView ? _jsxs(View, {
      children: [lottieView, (lottieViewProps === null || lottieViewProps === void 0 ? void 0 : lottieViewProps.withAnimationTitle) && _jsx(TypographyWidget, Object.assign({}, getTestId(testID, 'heading'), {
        style: DynamicDataCardWidgetStyles.animationText
      }, lottieViewProps === null || lottieViewProps === void 0 ? void 0 : lottieViewProps.withAnimationTitle, {
        onUserAction: onUserAction
      }))]
    }) : _jsxs(_Fragment, {
      children: [!!isValidObject(imageProps) && imagePosition === ImagePositionTypes.TOP && _jsx(ImageWidget, Object.assign({}, imageProps, {
        isDisabled: isDisabled
      })), !!isValidObject(cardSectionTitleProps) && _jsx(SectionTitleWidget, Object.assign({}, cardSectionTitleProps, !!cardSectionTitleRadioButtonSelected && {
        radioButtonProps: Object.assign({
          checked: cardSectionTitleRadioButtonSelected
        }, cardSectionTitleProps === null || cardSectionTitleProps === void 0 ? void 0 : cardSectionTitleProps.radioButtonProps)
      }, {
        isDisabled: isDisabled,
        style: DynamicDataCardWidgetStyles.sectionTitle,
        onUserAction: onUserAction
      })), !!isValidObject(imageProps) && imagePosition === ImagePositionTypes.BOTTOM && _jsx(ImageWidget, Object.assign({}, imageProps, {
        isDisabled: isDisabled,
        onUserAction: onUserAction
      })), (!!isValidObject(cardValueUnitProps) || !!isValidObject(cardSupportingInfoProps)) && _jsxs(View, Object.assign({
        style: [DynamicDataCardWidgetStyles.infoSection, infoSectionStyle]
      }, {
        children: [!!isValidObject(cardValueUnitProps) && _jsx(TypographyWidget, Object.assign({
          numberOfLines: 1,
          style: DynamicDataCardWidgetStyles.cardValueUnit
        }, cardValueUnitProps, {
          color: isDisabled ? BLACK_500 : cardValueUnitProps === null || cardValueUnitProps === void 0 ? void 0 : cardValueUnitProps.color,
          onUserAction: onUserAction
        })), !!isValidObject(cardSupportingInfoProps) && _jsx(TypographyWidget, Object.assign({
          numberOfLines: 1
        }, cardSupportingInfoProps, {
          color: isDisabled ? BLACK_500 : cardSupportingInfoProps === null || cardSupportingInfoProps === void 0 ? void 0 : cardSupportingInfoProps.color,
          onUserAction: onUserAction
        }))]
      })), !!isValidObject(cardSupportingDescriptionProps) && _jsx(TypographyWidget, Object.assign({
        numberOfLines: cardSupportingDescriptionNumberOfLines
      }, cardSupportingDescriptionProps, {
        color: isDisabled ? BLACK_500 : cardSupportingDescriptionProps === null || cardSupportingDescriptionProps === void 0 ? void 0 : cardSupportingDescriptionProps.color,
        onUserAction: onUserAction
      })), !!isValidObject(imageProps) && imagePosition === ImagePositionTypes.EXTREME_BOTTOM && _jsx(ImageWidget, Object.assign({}, imageProps, {
        isDisabled: isDisabled,
        onUserAction: onUserAction
      })), !!isValidObject(buttonProps) && _jsx(ButtonWidget, Object.assign({
        style: DynamicDataCardWidgetStyles.button
      }, buttonProps, {
        onUserAction: onUserAction
      })), infoTagText && _jsx(InfoTag, {
        style: DynamicDataCardWidgetStyles.infoType,
        size: isLargeScreen ? 'md' : 'sm',
        type: "inline",
        subType: infoTagSubType,
        text: infoTagText
      })]
    })
  }));
  var CardWithImageBackgroundJsx = _jsx(ImageBackground, Object.assign({
    imageStyle: {
      resizeMode: (backgroundImageProps === null || backgroundImageProps === void 0 ? void 0 : backgroundImageProps.resizeMode) || 'cover'
    },
    source: {
      uri: isLargeScreen ? (backgroundImageProps === null || backgroundImageProps === void 0 ? void 0 : backgroundImageProps.desktopUri) || '' : (backgroundImageProps === null || backgroundImageProps === void 0 ? void 0 : backgroundImageProps.mobileUri) || ''
    },
    style: [{
      flex: 1
    }, backgroundImageProps === null || backgroundImageProps === void 0 ? void 0 : backgroundImageProps.style]
  }, backgroundImageProps, getTestId(testID, 'backgroundImage'), {
    children: DynamicDataCardJsx
  }));
  var renderDynamicDataCard = () => {
    if (withBackgroundImage) {
      return CardWithImageBackgroundJsx;
    } else {
      return DynamicDataCardJsx;
    }
  };
  return _jsx(_Fragment, {
    children: type !== 'cardImg' ? renderDynamicDataCard() : _jsx(DynamicCardImg, Object.assign({
      id: id,
      infoTagMarginBottom: infoTagMarginBottom,
      showInfoIcon: showInfoIcon,
      tooltipProps: tooltipProps,
      imageProps: imageProps,
      heading: heading,
      descrptionNoOfLines: descrptionNoOfLines,
      headingNoOfLines: headingNoOfLines,
      headingType: headingType,
      resizeMode: resizeMode,
      description: description,
      infoTagSize: infoTagSize,
      infoTagType: infoTagType,
      infoTagSubType: infoTagSubType,
      logoUrl: logoUrl,
      showLogo: showLogo,
      logoStyles: logoStyles,
      infoTagText: infoTagText,
      buttonProps: buttonProps,
      infoIconName: infoIconName,
      showCtaAtBottom: showCtaAtBottom,
      infoIconPosition: infoIconPosition,
      style: style,
      onUserAction: onUserAction,
      onCardPressMetaData: onCardPressMetaData,
      isCardOnPressDisabled: isCardOnPressDisabled,
      wrapperStyle: wrapperStyle,
      logoResizeMode: logoResizeMode
    }, cardImgProps))
  });
};
DynamicDataCardWidgetComponent.genericRendererKey = 'AirDynamicDataCard';